import React from 'react';
import { UiView, UiViewContent } from "../../../library/layout/Index";
import SarasTrans from '../../../library/notifications/SarasTrans'
import InvImportItemsRow from './InvImportItemsRow'
import FormWrapper from '../../../library/form/components/FormWrapper';

const InvImportItems = (props) => {
    const { formObject, viewData, rowSelector } = props;


    const generateImportRows = () => {
        // console.log("import",viewData)
        if (viewData)
            return (
                Object.values(viewData).map((row, index) => (
                    <InvImportItemsRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} />
                ))
            )
    }

    return (
        <UiView>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Select" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Type" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item ID" /></li>
                            <li className="uiColumnCenter " style={{width:"150px"}}><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Pending Qty" /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Unit Cost" /></li>
                            <FormWrapper customWrapper="li" wrapperClass="uiColumnCenter uiColumn100" 
                                formObject={formObject} rowKey="" action={{ paramName: "itemAmount" }} >
                                <SarasTrans value="Pending Amt" />
                            </FormWrapper>
                        </ul>
                    </li>
                    {
                        generateImportRows()
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default InvImportItems